import { createRouter, createWebHashHistory } from "vue-router"
import Home from "../views/Home/index.vue"
import About from "../views/About/index.vue"
import Contact from "../views/Contact/index.vue"
import Project from "../views/Project/index.vue"

const routes = [
  {
    path: "/",
    redirect: "/home/"
  },
  {
    path: "/home/",
    component: Home,
    props: true
  },
  {
    path: "/home/:location",
    name: "Home",
    component: Home,
    props: true
  },
  {
    path: "/about",
    name: "About",
    component: About
  },
  {
    path: "/resume",
    redirect: "/home"
  },
  {
    path: "/work",
    redirect: "/home"
  },
  {
    path: "/Project/:title",
    component: Project,
    props: true
  },
  {
    path: "/contact",
    name: "Contact",
    component: Contact
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior() {
    window.scrollTo({ left: 0, top: 0, behavior: 'auto' })
  }
})


export default router
